import { useFormatShortDate as formatShortDate, useFormatTime as formatTime, } from '@coolblue-development/next-formatting-utils/client';
import { isTomorrow } from '../isTomorrow/isTomorrow.js';
export const getTemporaryOutOfStockAvailability = ({ isPickupOnly, nextPickupDateTime, timeTravelOverride, t, }) => {
    const pickupDay = formatShortDate(new Date(nextPickupDateTime));
    const pickupTime = formatTime(new Date(nextPickupDateTime));
    const isTomorrowPickupDay = isTomorrow(new Date(nextPickupDateTime), timeTravelOverride);
    let description;
    if (isPickupOnly) {
        description = t('notAvailableForPickup');
    }
    else {
        description = isTomorrowPickupDay
            ? t('temporaryOutOfStockPickupTomorrow', { pickupTime })
            : t('temporaryOutOfStockPickup', { pickupDay, pickupTime });
    }
    return {
        promise: t('temporaryOutOfStock'),
        description,
    };
};
//# sourceMappingURL=getTemporaryOutOfStockAvailability.js.map